(() => {
  const section = document.querySelector('[data-grind-product-story]');
  const sticky = section?.querySelector('[data-grind-sticky]');
  const primaryButton = document.querySelector('.product-form__submit');
  if (!section || !sticky || !primaryButton) return;

  const stickyButton = sticky.querySelector('button');
  const productForm = document.querySelector('product-form form[action*="/cart/add"]');
  const sync = () => {
    stickyButton.disabled = primaryButton.disabled;
    stickyButton.textContent = primaryButton.disabled ? 'Sold out' : 'Add to cart';
  };
  sync();
  new MutationObserver(sync).observe(primaryButton, { attributes: true, childList: true, subtree: true });
  stickyButton.addEventListener('click', () => productForm?.requestSubmit(primaryButton));
  new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(primaryButton);
})();
